import React from "react";
import Typography from "@material-ui/core/Typography";

import { rows } from "./data";
import i0 from '../../../../assets/24/doclads/Акманова С. (НУ).pdf'
import i1 from '../../../../assets/24/doclads/Атанов А.В. (КФА).pdf'
import i2 from '../../../../assets/24/doclads/Багиров Ш.Г. (НУ).pdf'
import i3 from '../../../../assets/24/doclads/Бадулина Н. А. (КФА).pdf'
import i4 from '../../../../assets/24/doclads/Великанов_Хуан Жуй_ (ДУ).pdf'
import i5 from '../../../../assets/24/doclads/Гермидер О., Попов В. (НУ).pdf'
import i6 from '../../../../assets/24/doclads/Даллул Мариана  (КФА).pdf'
import i7 from '../../../../assets/24/doclads/Дусанова У. (ДУ).pdf'
import i8 from '../../../../assets/24/doclads/Евтина Д, Жабко А. (ДУ).pdf'
import i9 from '../../../../assets/24/doclads/Жабко А., Гапонов Д. (ММ).pdf'
import i10 from '../../../../assets/24/doclads/Зацепин Д. (КФА).pdf'
import i11 from '../../../../assets/24/doclads/Зверева М.Б. (ДУ).pdf'
import i12 from '../../../../assets/24/doclads/КАшникова А. (MM).pdf'
import i13 from '../../../../assets/24/doclads/Качалов В., Маслов Д. (НУ).pdf'
import i14 from '../../../../assets/24/doclads/Костенко И., Малютин К.  (КФА).pdf'
import i15 from '../../../../assets/24/doclads/Кризкий_Александров_Владов (ММ).pdf'
import i16 from '../../../../assets/24/doclads/Лискина_Алыпов_(ММ).pdf'
import i17 from '../../../../assets/24/doclads/Ломакина Е., Деревянко О. (КФА).pdf'
import i18 from '../../../../assets/24/doclads/Лукащук С., Спеле В. (ДУ).pdf'
import i19 from '../../../../assets/24/doclads/Максимов В.П. (ДУ).pdf'
import i20 from '../../../../assets/24/doclads/Малыгина А.С.  (ММ).pdf'
import i21 from '../../../../assets/24/doclads/Мальцева С., Деревцов Е. (ММ).pdf'
import i22 from '../../../../assets/24/doclads/Мурзагулова Ж., Мурзагулов Р. (НУ).pdf'
import i23 from '../../../../assets/24/doclads/Мухаметшин А. и др. (ММ).pdf'
import i24 from '../../../../assets/24/doclads/Наумова А.А. (КФА).pdf'
import i25 from '../../../../assets/24/doclads/Николаева Н., Манакова Н. (ДУ).pdf'
import i26 from '../../../../assets/24/doclads/Рассадин А., Рубцов М., Бугров В. (ММ).pdf'
import i27 from '../../../../assets/24/doclads/Россовский Г. (ДУ).pdf'
import i28 from '../../../../assets/24/doclads/Рябков К. (ММ).pdf'
import i29 from '../../../../assets/24/doclads/Сакиева А. (НУ).pdf'
import i30 from '../../../../assets/24/doclads/Сафонова Т. (СТО).pdf'
import i31 from '../../../../assets/24/doclads/Солиев Ю.С. (КФА).pdf'
import i32 from '../../../../assets/24/doclads/Степанов А., Чуновкина А. (ММ).pdf'
import i33 from '../../../../assets/24/doclads/Тимиргалеев С. (ДУ).pdf'
import i34 from '../../../../assets/24/doclads/Уфимская В.А. (ММ).pdf'
import i35 from '../../../../assets/24/doclads/Хадур Махмуд  (КФА).pdf'
import i36 from '../../../../assets/24/doclads/Хакимов А. (НУ).pdf'
import i37 from '../../../../assets/24/doclads/Читоркин Е. (СТО).pdf'
import i38 from '../../../../assets/24/doclads/Шабалин П. (ДУ).pdf'
import i39 from '../../../../assets/24/doclads/Эгамов А.И., Бураго П.Н. (ММ).pdf'
import { Box, makeStyles } from "@material-ui/core";
import LayoutPage from "../../../../hoc/LayoutPage/LayoutPage";



const StendReport = () => {

  const variables = [i0,
    i1,
    i2,
    i3,
    i4,
    i5,
    i6,
    i7,
    i8,
    i9,
    i10,
    i11,
    i12,
    i13,
    i14,
    i15,
    i16,
    i17,
    i18,
    i19,
    i20,
    i21,
    i22,
    i23,
    i24,
    i25,
    i26,
    i27,
    i28,
    i29,
    i30,
    i31,
    i32,
    i33,
    i34,
    i35,
    i36,
    i37,
    i38,
    i39,]

  return (
    <ol>

      {rows.map((row, index) =>
        <Typography component='li' variant="subtitle1">
          <a href={variables[index]}>{row}</a>
        </Typography>
      )}
    </ol>

  );
};

export default StendReport;
